import { render, staticRenderFns } from "./EmbedIcon.vue?vue&type=template&id=6097413e&scoped=true"
import script from "./EmbedIcon.vue?vue&type=script&lang=js"
export * from "./EmbedIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6097413e",
  null
  
)

export default component.exports